var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',{staticClass:"text-center "},[_c('v-col',[_c('SuperEffective')],1)],1)],1),_c('Support')],1)}
var staticRenderFns = []

export { render, staticRenderFns }